/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  profile: '个人信息',
  settings: '设置',
  name: '姓名',
  email: '电子邮件',
  password: '密码',
  passwordConfirmation: '重复密码',
  locale: '语言',
  view: '布局',
  comfortable: '宽松',
  compact: '紧凑',
  line: '间隔',
  full: '宽',
  narrow: '窄',
  sort: '排序',
  lastModifiedFirst: '按修改排序',
  lastCreatedFirst: '按创建排序',
  alphabetically: '按名称排序',
  theme: '主题',
  dark: '暗黑的',
  light: '明亮的',
  save: '保存',
  saveSuccess: '保存成功',
  saveFailure: '保存失败',
  fetchFailure: '无法获取配置信息',
  application: '应用',
  install: '安装',
  youCanInstallPlainpad: '此服务器可以安装Plainpad',
  invalidateCache: '无效的缓存',
  encrypt: '加密',
  yes: '是',
  no: '否',
  passwordsMismatch: '密码不匹配，请重试',
  invalidateCachePrompt: '确定要清除本地缓存吗？未同步的信息将会丢失'
}
